import type { ChipBadgeColor } from '@/components/ReviewsManagement/Reviews/types'
import { LeadStatusEnum } from '@/gql/reviews'

export const badgeColorByStatus: Record<LeadStatusEnum, ChipBadgeColor> = {
  [LeadStatusEnum.New]: 'default',
  [LeadStatusEnum.Contacted]: 'purple',
  [LeadStatusEnum.Won]: 'mint',
  [LeadStatusEnum.Lost]: 'error',
}

export const leadStatusOrder: LeadStatusEnum[] = [LeadStatusEnum.New, LeadStatusEnum.Contacted, LeadStatusEnum.Won, LeadStatusEnum.Lost]

export const leadStatusLabelKey = (status: LeadStatusEnum) => `Leads.status.${status}`
